var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CollapsibleList, SimpleListItem } from '@rmwc/list';
import React, { Component } from 'react';
var FieldSet = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("fieldset", __assign({ className: "madonna-field-legend " + className }, props)));
};
var LegendButton = function (_a) {
    var 
    // `onKeyDown` breaks enter key interaction; excluded from `button` props.
    onKeyDown = _a.onKeyDown, props = __rest(_a, ["onKeyDown"]);
    return (React.createElement("legend", { className: "legend-button" },
        React.createElement("button", __assign({}, props))));
};
/**
 * Field legend component. The legend and fieldset to group form controls.
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/invotra-components/fieldlegend.md
 */
var FieldLegend = /** @class */ (function (_super) {
    __extends(FieldLegend, _super);
    function FieldLegend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: false,
        };
        _this.handleClick = function () { return _this.setState({
            expanded: !_this.state.expanded,
        }); };
        return _this;
    }
    FieldLegend.prototype.render = function () {
        var _a = this.props, _b = _a.collapsible, collapsible = _b === void 0 ? false : _b, icon = _a.icon, title = _a.title, props = __rest(_a, ["collapsible", "icon", "title"]);
        return (React.createElement(CollapsibleList, __assign({ tag: FieldSet, "aria-expanded": collapsible ? this.state.expanded : undefined, open: !collapsible || undefined, handle: React.createElement(SimpleListItem, { tag: collapsible ? LegendButton : 'legend', graphic: icon, text: title, metaIcon: collapsible ? 'chevron_right' : undefined }), onOpen: this.handleClick, onClose: this.handleClick }, props)));
    };
    return FieldLegend;
}(Component));
export default FieldLegend;
//# sourceMappingURL=FieldLegend.js.map